import type { IntakeFormSlotKey } from '@super/shared-types'

export const SLOT_LABELS: Record<IntakeFormSlotKey, string> = {
  'contact.name': '{{ name }}',
  'contact.email': '{{ email }}',
  'contact.property': '{{ property }}',
  'contact.group': '{{ contact type }}',
}

export const SLOT_PROMPT_DEFAULTS: Record<
  IntakeFormSlotKey,
  { confirm: string; ask: string }
> = {
  'contact.name': {
    confirm: 'Just to confirm, am I speaking with {first_name}?',
    ask: 'May I get your name?',
  },
  'contact.email': {
    confirm:
      'I have a {email_domain} address on file — is that still the right one?',
    ask: 'Could I get a good email address for you?',
  },
  'contact.property': {
    confirm: 'Is this about the property on {street_name}?',
    ask: 'Which property is this call about?',
  },
  'contact.group': {
    confirm: "I see you're listed as a {role} — is that right?",
    ask: 'Are you calling as an owner, tenant, or vendor today?',
  },
}
